import React, { useEffect, useState } from "react";
import Layout from "../../../components/layout/Layout";
import { MdKeyboardArrowDown } from "react-icons/md";
import axios from "axios";
import Table from "react-bootstrap/Table";
import { useTranslation } from "react-i18next";
import { VscFilePdf } from "react-icons/vsc";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const IncomeStatements = () => {
  const mainLogoNew = `/assets/fakt-logo.png`;

  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const year = new Date().getUTCFullYear();
  const [spinner, setSpinner] = useState({
    spinner: false,
    Year: year,
  });

  const [incomeData, setincomeData] = useState({
    values: {},
    statusCode: null,
  });

  const [show, setShow] = useState({
    PDFModal: false,
  });

  const years = Array(year - (year - (year - 2021)))
    .fill("")
    .map((v, idx) => year - idx);

  const downloadData = async (year) => {
    setSpinner((prev) => ({
      ...prev,
      spinner: true,
      Year: year,
    }));

    try {
      const res = await axios.get(`/Salary/controldata?year=${year}`);
      setincomeData({
        values: res.data.response,
        statusCode: res.status,
      });
    } catch (error) {
      toast.error(
        `${t("Failed to fetch data for")} ${year}. ${t("Please try again!")}`
      );
    } finally {
      setSpinner((prev) => ({
        ...prev,
        spinner: false,
        Year: year,
      }));
    }
  };

  const handleDownloadPDF = () => {
    const element = document.getElementById("salary-modal");
    if (element) {
      html2canvas(element).then((canvas) => {
        const imgWidth = 210;
        const pageHeight = 290;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        const doc = new jsPDF("p", "mm"); // eslint-disable-line new-cap
        let position = 0;
        const pageData = canvas.toDataURL("image/jpeg", 1.0);
        const imgData = encodeURIComponent(pageData);
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        doc.setLineWidth(5);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 0, 210, 295);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          doc.setLineWidth(5);
          doc.setDrawColor(255, 255, 255);
          doc.rect(0, 0, 210, 295);
          heightLeft -= pageHeight;
        }
        doc.save("income-statement.pdf");
      });
    }
    setShow({ PDFModal: false });
  };

  useEffect(() => {
    mobileScroll();
  }, []);

  useEffect(() => {
   downloadData(year);
  }, []);

  return (
    <Layout
      className="p-4 mt-5 invoice-space2 topspace income-space"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/incomestatements"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/inkomstredovisningar"
          />
        )}
      </Helmet>
      <div className="page-content">
        <div className="agreements-list">
          <h4 className="accident_ins font-weight-bold">
            {t("Your statements")}
          </h4>

          <p>
            <span>{t("inchere")}</span>
          </p>
          <div className="select-btn-wrapper mt-4">
            <div className="styled-select">
              <MdKeyboardArrowDown
                className="text-primary arrow-down"
                size={30}
                style={{ pointerEvents: "none" }}
              />
              <select
                onChange={(e) => {
                  setSpinner({ Year: e.target.value });
                  setincomeData({ values: [], statusCode: null });
                  downloadData(e.target.value);
                }}
                disabled={spinner.spinner} 
                style={{
                  opacity: spinner.spinner ? 0.6 : 1, 
                }}
              >
                {years.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="w-100 mt-5 Scrollable-div">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>
                  {spinner.spinner
                    ? `${t("Founding Salary For")} ${spinner.Year}`
                    : `${t("Salary in")} ${spinner.Year}`}
                </th>
                <th>
                  {spinner.spinner
                    ? `${t("Founding Tax For")} ${spinner.Year}`
                    : `${t("Tax in")} ${spinner.Year}`}
                </th>
                <th>
                  {spinner.spinner
                    ? `${t("Founding Social Fee For")} ${spinner.Year}`
                    : `${t("Social Fee in")} ${spinner.Year}`}
                </th>
                <th>
                  {spinner.spinner
                    ? `${t("Founding Gross salary incl. holiday pay For")} ${
                        spinner.Year
                      }`
                    : `${t("Gross salary incl. holiday pay in")} ${
                        spinner.Year
                      }`}
                </th>
                <th>{t("Action")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {spinner.spinner ? (
                    <div
                      className="spinner-border text-primary spinner-border-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : incomeData?.values?.salary ? (
                    incomeData?.values?.salary
                  ) : incomeData.statusCode === 400 ? (
                    t("Found an Error")
                  ) : incomeData.statusCode === 200 &&
                    !incomeData?.values?.salary ? (
                    t("No data found")
                  ) : (
                    t("Something went wrong. Please try again!")
                  )}
                </td>

                <td>
                  {spinner.spinner ? (
                    <div
                      className="spinner-border text-primary spinner-border-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : incomeData?.values?.totalTax ? (
                    incomeData?.values?.totalTax
                  ) : incomeData.statusCode === 400 ? (
                    t("Found an Error")
                  ) : incomeData.statusCode === 200 &&
                    !incomeData?.values?.totalTax ? (
                    t("No data found")
                  ) : (
                    t("Something went wrong. Please try again!")
                  )}
                </td>

                <td>
                  {spinner.spinner ? (
                    <div
                      className="spinner-border text-primary spinner-border-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : incomeData?.values?.socialFee ? (
                    incomeData?.values?.socialFee
                  ) : incomeData.statusCode === 400 ? (
                    t("Found an Error")
                  ) : incomeData.statusCode === 200 &&
                    !incomeData?.values?.socialFee ? (
                    t("No data found")
                  ) : (
                    t("Something went wrong. Please try again!")
                  )}
                </td>

                <td>
                  {spinner.spinner ? (
                    <div
                      className="spinner-border text-primary spinner-border-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : incomeData?.values?.grossSalary ? (
                    incomeData?.values?.grossSalary
                  ) : incomeData.statusCode === 400 ? (
                    t("Found an Error")
                  ) : incomeData.statusCode === 200 &&
                    !incomeData?.values?.grossSalary ? (
                    t("No data found")
                  ) : (
                    t("Something went wrong. Please try again!")
                  )}
                </td>

                <td>
                  <div className="pdfIcon">
                    <VscFilePdf
                      title={t("Download PDF")}
                      onClick={() => {
                        if (
                          incomeData.statusCode === 200 &&
                          incomeData.values &&
                          incomeData.values.totalTax
                        ) {
                          setShow({ PDFModal: true });
                        } else if (incomeData.statusCode === 200) {
                          toast.error(
                            t(`${t("No data found")} ${t("for")} ${spinner.Year}`)
                          );
                        } else {
                          toast.error(
                            `${t("Fetching data for")} ${spinner.Year}. ${t("Please wait!")}`

                          );
                        }
                      }}
                      size={30}
                      style={{
                        pointerEvents: spinner.spinner ? "none" : "auto",
                        opacity: spinner.spinner ? 0.5 : 1,
                      }}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
      <Modal show={show.PDFModal} onHide={() => setShow({ PDFModal: false })}>
        <ModalHeader>
          {t("Download PDF")}.
          <AiOutlineClose
            size={25}
            onClick={() => setShow({ PDFModal: false })}
          />
        </ModalHeader>
        <ModalBody>
          <div id="salary-modal">
            <div className="page-content EconomyInvoices">
              <div className="invoice-details-part-container flex-column mt-4 w-100">
                <span className="invoice-details-title">
                  <img
                    className={`mr-4 mb-4 logo`}
                    src={mainLogoNew}
                    alt="site-logo"
                    loading="lazy"
                  />
                </span>
                <span className="invoice-details-title">
                  {t(`Monthly hour's`)} {spinner.Year}
                </span>
                <div className="mb-3">
                  <div className="d-flex justify-content-center flx_wrap">
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("January")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.janMonthHours || 0} Hr
                        </p>
                      </div>
                      {/* <p className="m-0">{t("January")}</p>
                      <p className="m-0 ml-auto">
                        Hr {incomeData?.values?.janMonthHours || 0}
                      </p> */}
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("February")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.febMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("March")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.marchMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("April")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.aprMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("May")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.mayMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("June")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.juneMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("July")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.julyMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("August")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.augMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("September")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.septMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("October")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.octMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("November")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.novMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                    <div className="width_set">
                      <div className="clr_rund">
                        <p className="m-0">{t("December")}</p>
                      </div>
                      <div className="border_set text-center">
                        <p className="m-0 ml-auto">
                          {incomeData?.values?.decMonthHours || 0} Hr
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <span className="invoice-details-title">
                  {t(`Your statements for`)} {spinner.Year}
                </span>
              </div>
              <div>
                <div className="d-flex bordr_bottm align-items-center mb-2">
                  <p className="m-0">{t("Salary")}</p>
                  <p className="m-0 ml-auto">
                    SEK {incomeData?.values?.salary || 0}
                  </p>
                </div>
                <div className="d-flex bordr_bottm align-items-center mb-2">
                  <p className="m-0">{t("Tax")}</p>
                  <p className="m-0 ml-auto">
                    SEK {incomeData?.values?.totalTax || 0}
                  </p>
                </div>
                <div className="d-flex bordr_bottm align-items-center mb-2">
                  <p className="m-0">{t("Social Fee")}</p>
                  <p className="m-0 ml-auto">
                    SEK {incomeData?.values?.socialFee || 0}
                  </p>
                </div>
                <div className="d-flex bordr_bottm align-items-center mb-2">
                  <p className="m-0">{t("Gross salary incl. holiday pay")}</p>
                  <p className="m-0 ml-auto">
                    SEK {incomeData?.values?.grossSalary || 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="repsv_in">
          <button
            className="outline_btn_new"
            variant="secondary"
            onClick={() => setShow({ PDFModal: false })}
          >
            {t("Cancel")}
          </button>
          <Button
            className="new_theme_btn "
            onClick={() => handleDownloadPDF()}
          >
            {t("Download")}
          </Button>
        </ModalFooter>
      </Modal>
    </Layout>
  );
};

export default IncomeStatements;
